import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchPublicConfig } from '../services/shipments';

const ConfigContext = createContext({ config: null, loading: true });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchPublicConfig()
      .then((c) => { if (mounted) setConfig(c); })
      .catch(() => {
        if (mounted) {
          setConfig({
            app_name: 'ComplyTradeIQ',
            contact_email: 'info@complytradeiq.com',
            enable_login: true,
            enable_public_auth: false,
            enable_self_signup: false,
            enable_pilot_requests: true,
          });
        }
      })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
